import React from 'react';
export function Footer() {
  return <footer className="mt-20 pt-8 border-t border-gray-200" data-id="element-64">
      <div className="mb-6" data-id="element-65">
        <a href="https://track.marthaslife.blog/click" target="_blank" rel="noopener noreferrer" className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300 w-full md:w-auto text-center cursor-pointer" onClick={() => {
        try {
          nbpix('event', 'lander_click');
        } catch (e) {
          console.warn('NB pixel not available', e);
        }
      }} data-id="element-66">
          See the Formula I Use
        </a>
      </div>
      <div className="text-sm text-gray-500 mb-4" data-id="element-67">
        <h3 className="font-medium text-gray-700 mb-2" data-id="element-68">Disclaimer:</h3>
        <p data-id="element-69">
          The statements made on this page have not been evaluated by the Food
          and Drug Administration. This product is not intended to diagnose,
          treat, cure, or prevent any disease. The information provided is for
          informational purposes only and is not intended as a substitute for
          advice from your physician or healthcare professional. You should
          consult with a healthcare professional before starting any diet,
          exercise, or supplementation program, especially if you are pregnant,
          nursing, have a medical condition, or are taking medication.
          Individual results may vary.
        </p>
      </div>
      <div className="text-xs text-gray-400 text-center pt-4 border-t border-gray-200" data-id="element-70">
        <p data-id="element-71">© 2023 Martha Lane's Blog. All Rights Reserved.</p>
      </div>
    </footer>;
}